import React, {memo, useRef, useState} from 'react'
import cx from 'classnames'

/* Components */
import OptionItem from './option/OptionItem'

/* Hooks */
import useOutsideClick from '../../../../../../hooks/useOutsideClick'

/* Styles */
import s from './select.scss'

const Select = memo(({
  options,
  name,
  id,
  value,
  onChange,
  onFocus,
  onBlur,
  disabled,
  placeholder,
  optionsWrapperClassName,
  unAvailableVariants,
  isAvailableProduct,
  activeVariant
}) => {
  const selectRef = useRef(null);
  const selectedItem = options?.find((x) => x.value === value)
  const [isOptionsVisible, setIsOptionsVisible] = useState(false)
  const [searchValue, setSearchValue] = useState('')

  const showOptions = () => {
    if (onFocus) {
      onFocus();
    }
    setIsOptionsVisible(true);
  };

  const hideOptions = () => {
    if (onBlur) {
      onBlur();
    }
    setIsOptionsVisible(false);
    setSearchValue('');
  };

  const showHideOptions = () => {
    if (isOptionsVisible) {
      hideOptions();
    } else {
      showOptions();
    }
  };


  useOutsideClick(selectRef, () => {
    if (isOptionsVisible) {
      hideOptions();
    }
  });

  const onSelectChange = (selectedValue) => {
    onChange(selectedValue);
    hideOptions();
  };

  const getVisibleOptions = () => {
    if (options?.length) {
      return options?.filter((x) =>
        x?.label?.
          toLocaleLowerCase('tr-TR').
          includes(searchValue?.toLocaleLowerCase('tr-TR')),
      );
    }
    return [];
  };

  const optionList = getVisibleOptions()

  return (
    <div className={cx(s.root)} ref={selectRef} disabled={disabled}>
      <select
        id={`select-${id}`}
        name={name}
        hidden
        value={selectedItem?.value}
        disabled={disabled}>
        {
          options?.map((item) => (
            <option value={item?.value} key={item?.value} id={item?.value}>
              {item?.label}
            </option>
          ))
        }
      </select>
      <div className={s.selectWrapper}>
        <button
          aria-haspopup='true'
          aria-controls='variant-menu'
          className={cx(s.selectContent, {[s.disabled]: disabled})}
          value={selectedItem?.value}
          onClick={showHideOptions}
          aria-label={`Seçili ${selectedItem?.label}`}
          data-test-id='select-dropdown'>
          {placeholder}
          <div className={s.iconContent}>
            <i className={s.icon} aria-hidden/>
          </div>
        </button>
        {
          isOptionsVisible && (
            <div className={cx(s.optionsWrapper, optionsWrapperClassName)} role='menu' id='variant-menu' aria-label='Seçenekler'>
              {
                optionList?.map((option) => (
                  <OptionItem
                    key={option.value}
                    option={option}
                    activeVariant={activeVariant}
                    unAvailableVariants={unAvailableVariants}
                    isAvailableProduct={isAvailableProduct}
                    isDisabled={(selectedItem?.value === option?.value) && (!isAvailableProduct || !selectedItem?.extraProps?.isInStock)}
                    isSelected={selectedItem?.value === option?.value}
                    onSelectChange={onSelectChange}/>
                ))
              }
              {!optionList.length && <div className={s.notFound}>{'Bulunamadı'}</div>}
            </div>
          )
        }
      </div>
    </div>
  );
})

export default Select
